module.exports = __webpack_public_path__ + "img/xuehua.c7854531.png";